var _path, _path2, _line, _line2, _line3, _line4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.541L2 13.541",
    stroke: "current",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.541L12 8.54102C12 6.33188 10.2091 4.54102 8 4.54102V4.54102C5.79086 4.54102 4 6.33188 4 8.54102L4 13.541",
    stroke: "current",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.99988,
    y1: 3,
    x2: 7.99988,
    y2: 1,
    stroke: "current",
    fill: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.99988,
    y1: 13.1765,
    x2: 7.99988,
    y2: 11.1765,
    stroke: "current",
    fill: "none"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.02173,
    y1: 3.43301,
    x2: 2.28968,
    y2: 2.43301,
    stroke: "current",
    fill: "none"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 2,
    y2: -0.5,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 11.7283 3)",
    stroke: "current",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 10.541,
    r: 1,
    fill: "current",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.7575ccf713145007f1eaf2c6838f3881.svg";
export { ForwardRef as ReactComponent };